import { useRef, useState, useEffect } from "react";

export default function BeforeAfter({ before, after, title }) {
  const wrapRef = useRef(null);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);

  const setFromClientX = (clientX) => {
    const el = wrapRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    let x = ((clientX - rect.left) / rect.width) * 100;
    x = Math.max(0, Math.min(100, x));
    setPos(x);
  };

  useEffect(() => {
    const onMove = (e) => {
      if (!dragging.current) return;
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setFromClientX(clientX);
    };
    const onUp = () => (dragging.current = false);
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
    window.addEventListener("touchmove", onMove);
    window.addEventListener("touchend", onUp);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
      window.removeEventListener("touchmove", onMove);
      window.removeEventListener("touchend", onUp);
    };
  }, []);

  return (
    <div data-testid={`ba-slider-${title?.replace(/\s+/g, "-").toLowerCase()}`} className="space-y-3">
      <div
        ref={wrapRef}
        className="ba-wrapper"
        onMouseDown={(e) => { dragging.current = true; setFromClientX(e.clientX); }}
        onTouchStart={(e) => { dragging.current = true; setFromClientX(e.touches[0].clientX); }}
      >
        <img src={after} alt={`${title} after`} />
        <div className="ba-clip" style={{ width: `${pos}%` }}>
          <img src={before} alt={`${title} before`} />
        </div>
        <span className="ba-label" style={{ left: 14 }}>Before</span>
        <span className="ba-label" style={{ right: 14 }}>After</span>
        <div className="ba-handle" style={{ left: `${pos}%` }} />
      </div>
      <p className="text-center text-sm text-white/70 tracking-widest uppercase">{title}</p>
    </div>
  );
}
